module.exports = __webpack_public_path__ + "img/3-2.fa12ea35.svg";